package fr.arcplex.sooner

data class VideoInfo(
    var title: String = "",
    var description: String = "",
    var artworkUrl: String? = null
) {
    var actions: List<String> = listOf()
    var casting: List<String> = listOf()
    var director: String? = null
    var tags: List<String> = listOf()
    var infostech: String? = null
    var because: String? = null
}
